import { Box, BoxProps } from '@material-ui/core';
import React, { FC } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import css from './Navbar.module.css';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

interface NavbarProps {
  wrapperBoxOverrides?: Partial<BoxProps>;
  id?: string;
  type?: string;
  children?: React.ReactNode;
}

export const enum NavbarType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

const Navbar: FC<NavbarProps> = (props) => {
  const { children, wrapperBoxOverrides, id, type = NavbarType.Primary } = props;
  const isPrimaryNav = type === NavbarType.Primary;
  const isMobile = useIsMobile();
  const { shopColor10 } = useDefaultShopStyles();

  const backgroundColor = isPrimaryNav ? shopColor10 : '#ffffff';

  const desktopHeight = isPrimaryNav ? 2 : 1.5;

  return (
    // Screen Width Container
    <Box py={isMobile ? 0 : desktopHeight} px={isMobile ? 0 : 8} bgcolor={backgroundColor} id={id}>
      {/* Content Width Container */}
      <Box
        px={isMobile ? 2 : 0}
        py={isMobile ? 1 : undefined}
        className={css.root}
        display="flex"
        alignItems="center"
        {...wrapperBoxOverrides}
      >
        {children}
      </Box>
    </Box>
  );
};
export default Navbar;
